// extracted by mini-css-extract-plugin
export default {"image":"profile-photo_image__iMbzb"};